import { cn } from "@/lib/utils";

export function initialsOf(name: string): string {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word[0]!)
      .slice(0, 2)
      .join("")
      .toUpperCase() || "?"
  );
}

/** Up to four overlapping initials circles, then "+n". */
export function AvatarStack({ names, max = 4 }: { names: string[]; max?: number }) {
  const shown = names.slice(0, max);
  const rest = names.length - shown.length;
  return (
    <span className="flex items-center" aria-hidden="true">
      {shown.map((name, index) => (
        <span
          key={`${name}-${index}`}
          className={cn(
            "flex h-7 w-7 items-center justify-center rounded-g-pill border-2 border-g-bg-card bg-g-primary-tint text-[10px] font-bold text-g-primary-press",
            index > 0 && "-ml-2",
          )}
        >
          {initialsOf(name)}
        </span>
      ))}
      {rest > 0 ? (
        <span className="-ml-2 flex h-7 w-7 items-center justify-center rounded-g-pill border-2 border-g-bg-card bg-g-bg-track text-[10px] font-bold text-g-ink-600">
          +{rest}
        </span>
      ) : null}
    </span>
  );
}
